import ngMaterial from 'angular-material';
import uiRouter from 'angular-ui-router';

// import modules this module depends on
import angularTranslate from 'angular-translate';
import rnHttp from 'rhino/src/core/http/http.module';
import * as lfCode from './lf-code.controller';

// import this modules components
import './lf-code.scss';

// define the module in one place and export the module name
export default angular.module('register.components.lfCode', [
  uiRouter,
  ngMaterial,
  angularTranslate,
  'rhino.core',
  rnHttp,
  'angulartics'
])
  .controller(lfCode.name, lfCode.default)
  .name;



// WEBPACK FOOTER //
// ./components/lf-code/lf-code.module.js